import {
    FASTSHIFT_ROLL_UP_STATUS,
    FASTSHIFT_ROLL_UP_STATUS_AGGREGATED,
    FastshiftRollUpStatusAggregated,
    FastshiftRollUpStatus
} from "@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types";

import { messages } from "./messages";

/**
 * Returns the lozenge appearance color for a rollup status.
 * Falls back to 'default' for unknown statuses.
 *
 * @param status - The rollup status
 * @returns The lozenge appearance color
 */
export const getStatusColor = (status: FastshiftRollUpStatus | null) => {
    switch (status) {
        case FASTSHIFT_ROLL_UP_STATUS.COMPLETE:
        case FASTSHIFT_ROLL_UP_STATUS.ON_TRACK:
            return "success";
        case FASTSHIFT_ROLL_UP_STATUS.AT_RISK_ATLASSIAN_OWNED:
            return "inprogress";
        case FASTSHIFT_ROLL_UP_STATUS.AT_RISK_PARTNER_OWNED:
            return "new";
        case FASTSHIFT_ROLL_UP_STATUS.NEEDS_CUSTOMER_ATTENTION:
            return "moved";
        case FASTSHIFT_ROLL_UP_STATUS.TO_DO:
        default:
            return "default";
    }
};

/**
 * Returns the lozenge appearance color for an aggregated rollup status.
 * Falls back to 'default' for unknown statuses.
 *
 * @param status - The aggregated rollup status
 * @returns The lozenge appearance color
 */
export const getAggregatedStatusColor = (
    status: FastshiftRollUpStatusAggregated | null
) => {
    switch (status) {
        case FASTSHIFT_ROLL_UP_STATUS_AGGREGATED.COMPLETE:
        case FASTSHIFT_ROLL_UP_STATUS_AGGREGATED.ON_TRACK:
            return "success";
        case FASTSHIFT_ROLL_UP_STATUS_AGGREGATED.NEEDS_ATTENTION:
            return "moved";
        default:
            return "default";
    }
};

/**
 * Returns the display message for a rollup status.
 * For unknown statuses, returns a fallback message instead of null to prevent UI crashes.
 *
 * @param status - The rollup status
 * @returns The internationalized message for the status, or a fallback for unknown statuses
 */
export const getStatusText = (status: FastshiftRollUpStatus | null) => {
    switch (status) {
        case FASTSHIFT_ROLL_UP_STATUS.COMPLETE:
            return messages.rollUpStatusComplete;
        case FASTSHIFT_ROLL_UP_STATUS.ON_TRACK:
            return messages.rollUpStatusOnTrack;
        case FASTSHIFT_ROLL_UP_STATUS.AT_RISK_ATLASSIAN_OWNED:
            return messages.rollUpStatusAtRiskAtlassianOwned;
        case FASTSHIFT_ROLL_UP_STATUS.AT_RISK_PARTNER_OWNED:
            return messages.rollUpStatusAtRiskPartnerOwned;
        case FASTSHIFT_ROLL_UP_STATUS.NEEDS_CUSTOMER_ATTENTION:
            return messages.rollUpStatusNeedsCustomerAttention;
        case FASTSHIFT_ROLL_UP_STATUS.TO_DO:
            return messages.rollUpStatusToDo;
        default:
            return messages.rollUpStatusUnknown;
    }
};

/**
 * Returns the display message for an aggregated rollup status.
 * For unknown statuses, returns a fallback message instead of null to prevent UI crashes.
 *
 * @param status - The aggregated rollup status
 * @returns The internationalized message for the status, or a fallback for unknown statuses
 */
export const getAggregatedStatusText = (
    status: FastshiftRollUpStatusAggregated | null
) => {
    switch (status) {
        case FASTSHIFT_ROLL_UP_STATUS_AGGREGATED.COMPLETE:
            return messages.rollUpStatusComplete;
        case FASTSHIFT_ROLL_UP_STATUS_AGGREGATED.ON_TRACK:
            return messages.rollUpStatusOnTrack;
        case FASTSHIFT_ROLL_UP_STATUS_AGGREGATED.NEEDS_ATTENTION:
            return messages.rollUpStatusNeedsAttention;
        default:
            return messages.rollUpStatusUnknown;
    }
};
